import React from 'react'
import { useLocation, useParams } from 'react-router'

export interface AppointmentQueryParams {
  id?: string
  queryBusinessId?: string
  queryResourceId?: string
}

export const useAppointmentQueryParams = (): AppointmentQueryParams => {
  const { id } = useParams<{ id?: string }>()
  const location = useLocation()
  const query = React.useMemo(() => new URLSearchParams(location.search), [location.search])
  return {
    id,
    queryBusinessId: query.get('businessId') || undefined,
    queryResourceId: query.get('resourceId') || undefined,
  }
}
